import { accountDetails } from "@di";
import { UPDATE_ACCOUNT_DETAILS } from "../userdetail";
export const fetchAccountDetails = () => async (dispatch, getState) => {
    const accountCode = await accountDetails.getParsedAccountCode();
    const accountData = {
        accTyp: await accountDetails.getAccTyp(),
        userID: await accountDetails.getUserID(),
        emaildId: await accountDetails.getEmailId(),
        accountCode: accountCode,
        lgnSrc: await accountDetails.getLoginSrc(),
        empOrDependent: await accountDetails.getEmpOrDependent(),
        isImpersonated: await accountDetails.getCipFlag(),
        userName: (await accountDetails.getEqAccName())
            ? await accountDetails.getEqAccName()
            : await accountDetails.getCoAccName(),
    };
    dispatch({ type: UPDATE_ACCOUNT_DETAILS, payload: accountData });
};
